import Text from '@deprecated-ui/common/Text';
import color from '@deprecated-ui/_style/color';
import Image from 'global/Image';
import { EventBadgeContainer, PlayerHeaderContainer } from './styled';

interface PlayerHeaderProps {
  title: string;
  status: string;
  isLive: boolean;
}

const LABEL = {
  EVENT_STATUS_UPCOMING: 'Upcoming',
  EVENT_STATUS_LIVE: 'LIVE',
  EVENT_STATUS_ENDED: 'Live Ended',
};

function PlayerHeader({ title, status, isLive }: PlayerHeaderProps) {
  return (
    // @ts-expect-error
    <PlayerHeaderContainer status={status} id="livestream-player-header">
      <Text
        color={color.light}
        size="16px"
        height="22px"
        family="bold"
        weight="700"
        id="livestream-player-header-title"
      >
        {title}
      </Text>
      {/* @ts-expect-error */}
      <EventBadgeContainer status={status} id="livestream-player-header-badge">
        {isLive && (
          <Image
            src="/icon/dot-light.svg"
            id="livestream-player-header-badge-live"
          />
        )}
        <Text
          color={color.light}
          size="11px"
          // @ts-expect-error
          ml="4px"
          width="max-content"
          family="bold"
          id="livestream-player-header-badge-status"
        >
          {LABEL[status] ? LABEL[status] : ''}
        </Text>
      </EventBadgeContainer>
    </PlayerHeaderContainer>
  );
}

export default PlayerHeader;
